(() => {
  "use strict";
  const configNode = document.querySelector("[data-elookus-stock-config]");
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const variants = config.variants;
  const text = config.text;
  const form = document.querySelector('form[data-product-id="' + config.productId + '"].js-product-form');
  const scope = form?.closest("product-form");
  if (!scope) return;
  let scheduled = false;
  const entryButtons = "[data-elv2-preboot-action],[data-elv2-start-lenses],[data-elv2-frame-only],[data-elv2-frame-cart],[data-elv2-choose-lenses]";
  const anyAvailable = variants.some((variant) => variant.available);

  function selection() {
    const picker = scope.querySelector("variant-picker");
    const selectors = picker ? Array.from(picker.querySelectorAll(".option-selector:not(.option-selector--custom)")) : [];
    if (selectors.length) {
      const options = selectors.map((selector) => {
        const selected = selector.querySelector("input.js-option:checked, .js-option[aria-selected='true']");
        return selected ? selected.value || selected.dataset.value || selected.textContent.trim() : null;
      });
      if (options.some((value) => value === null)) return null;
      return variants.find((variant) => variant.options.length === options.length && variant.options.every((value, index) => value === options[index])) || null;
    }
    const id = scope.querySelector(".js-product-form [name='id']")?.value;
    return variants.find((variant) => String(variant.id) === String(id)) || null;
  }

  function status() {
    const variant = selection();
    if (!variant) return { kind: "choose", variant: null };
    if (!variant.available) return { kind: "soldout", variant };
    const currentId = scope.querySelector(".js-product-form [name='id']")?.value;
    return { kind: String(currentId) === String(variant.id) ? "available" : "pending", variant };
  }

  function messageFor(kind) {
    if (kind === "soldout") return anyAvailable ? text.colorSoldOut : text.productSoldOut;
    if (kind === "pending") return text.updating;
    if (kind === "choose") return text.chooseColor;
    return "";
  }

  function assignText(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  function stockNote() {
    let note = scope.querySelector("[data-elookus-stock-note]");
    if (!note) {
      const picker = scope.querySelector("variant-picker");
      if (!picker) return null;
      note = document.createElement("p");
      note.className = "elookus-stock-note";
      note.dataset.elookusStockNote = "";
      note.setAttribute("role", "status");
      note.setAttribute("aria-live", "polite");
      picker.after(note);
    }
    return note;
  }

  function updateColors() {
    scope.querySelectorAll('variant-picker .option-selector[data-option="Color"] input.js-option').forEach((input) => {
      const label = input.nextElementSibling;
      if (!label?.classList.contains("elookus-color-thumb")) return;
      const matches = variants.filter((variant) => variant.options[config.colorIndex] === input.value);
      const soldout = matches.length > 0 && !matches.some((variant) => variant.available);
      label.classList.toggle("elookus-color-thumb--soldout", soldout);
      const accessible = soldout ? input.value + " — " + text.soldOut : input.value;
      if (input.getAttribute("aria-label") !== accessible) input.setAttribute("aria-label", accessible);
      if (label.title !== accessible) label.title = accessible;
      let badge = label.querySelector(".elookus-color-stock");
      if (soldout && !badge) {
        badge = document.createElement("span");
        badge.className = "elookus-color-stock";
        badge.setAttribute("aria-hidden", "true");
        badge.textContent = text.soldOut;
        label.append(badge);
      } else if (!soldout && badge) {
        badge.remove();
      }
    });
  }

  function updateEntries(current) {
    scope.querySelectorAll(".elv2-entry").forEach((entry) => {
      if (entry.dataset.elookusStock !== current.kind) entry.dataset.elookusStock = current.kind;
      const blocked = current.kind !== "available";
      entry.querySelectorAll(entryButtons).forEach((button) => {
        if (blocked) {
          if (!button.hasAttribute("data-elookus-stock-disabled")) {
            button.dataset.elookusStockDisabled = button.disabled ? "true" : "false";
          }
          if (!button.disabled) button.disabled = true;
        } else if (button.hasAttribute("data-elookus-stock-disabled")) {
          button.disabled = button.dataset.elookusStockDisabled === "true";
          button.removeAttribute("data-elookus-stock-disabled");
        }
      });
      let button = entry.querySelector("[data-elookus-soldout-button]");
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.disabled = true;
        button.className = "elookus-soldout-button";
        button.dataset.elookusSoldoutButton = "";
        entry.append(button);
      }
      if (button.hidden !== !blocked) button.hidden = !blocked;
      assignText(button, current.kind === "soldout" ? text.soldOut : messageFor(current.kind));
    });
  }

  function refresh() {
    const current = status();
    const note = stockNote();
    if (note) {
      assignText(note, messageFor(current.kind));
      if (note.hidden !== (current.kind === "available")) note.hidden = current.kind === "available";
    }
    updateColors();
    updateEntries(current);
    return current.kind === "available";
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      refresh();
    });
  }

  function clearError() {
    scope.querySelectorAll("[data-elookus-frame-error]").forEach((element) => element.remove());
  }

  function showFrameError(message) {
    const entry = scope.querySelector(".elv2-entry:not([data-elv2-server-entry])") || scope.querySelector(".elv2-entry");
    if (!entry) return;
    let error = entry.querySelector("[data-elookus-frame-error]");
    if (!error) {
      error = document.createElement("p");
      error.className = "elookus-frame-error";
      error.dataset.elookusFrameError = "";
      error.setAttribute("role", "alert");
      entry.append(error);
    }
    error.textContent = message || text.cartError;
  }

  window.ElookusAvailability = { canPurchase: refresh, refresh: schedule, showFrameError, clearError };
  scope.addEventListener("click", (event) => {
    const target = event.target.closest(entryButtons);
    if (!target) return;
    if (!refresh()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    } else {
      clearError();
    }
  }, true);
  scope.addEventListener("change", (event) => {
    if (!event.target.closest("variant-picker")) return;
    clearError();
    refresh();
  }, true);
  scope.addEventListener("on:variant:change", () => {
    clearError();
    schedule();
  });
  document.addEventListener("elookus:lens-flow-v2-ready", schedule);
  window.addEventListener("pageshow", schedule);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) =>
      mutation.type === "childList" ||
      (mutation.target.matches?.(".js-product-form [name='id']") && mutation.attributeName === "value")
    )) schedule();
  }).observe(scope, { childList: true, subtree: true, attributes: true, attributeFilter: ["value"] });
  refresh();
})();